import $ from 'jquery';


class DataBinder {
    constructor(){
        this.bindings = $([]);
        $(document).on('change', ':input[data-bind]', this.processBindings);
        $(document).on('keyup', ':input[data-bind][data-bind-keyup]', this.processBindings);    
    }
    
    registerBinding(binding){
        if (!this.bindings.filter(binding).length) {
            this.bindings = this.bindings.add(binding);
        }
    }
    
    run(context){
        $('[data-bind], [data-bind-attr]', context).add($(context).is('[data-bind], [data-bind-attr]') ? context : []).each(function(){
            databinder.registerBinding(this);
        });
    }

    processBindings(){
        let me = $(this),
            value = me.val(),
            stateful = false;
        
        if (me.is('input[type=checkbox], input[type=radio]') && !me.is(':checked')) {
            stateful = true;
            value = 0;
        }

        $(databinder.bindings).filter('[data-bind="'+me.data('bind')+'"], [data-bind-attr^="'+me.data('bind')+':"]').not(me).each(function () {
            let newValue = value,
                target = $(this);
            
            if (!value && !stateful) {
                newValue = target.data('bind-default');
            }

            if (target.is('[data-bind-attr^="'+me.data('bind')+':"]')) {
                let attr = target.attr('data-bind-attr').split(':')[1];
                target.attr(attr, newValue);
            }
    
            if (target.is('[data-bind="'+me.data('bind')+'"]')) {
                if (target.is(':input')) {
                    target.val(newValue);
                }
                else {
                    target.text(newValue);
                }
            }
        });
    }
}

export const databinder = new DataBinder();

export default databinder;